// управляет показом или сокрытием скролбара страницы
// (используется при показе модальных окон)

const scrollBar = {
  show() {
    document.body.style.margin = '';
    document.body.style.overflow = '';
  },

  hide() {
    const scrollBarWidth = window.innerWidth - document.body.offsetWidth;
    document.body.style.margin = '0px ' + scrollBarWidth + 'px 0px 0px';
    document.body.style.overflow = 'hidden';
  }
};

export default scrollBar;